import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=06ff8077&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"
import style0 from "./Logo.vue?vue&type=style&index=0&id=06ff8077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff8077",
  null
  
)

export default component.exports